/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_StorefrontInputs */

const en_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront`)
};

const es_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda`)
};

const fr_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const de_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront`)
};

const ja_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロント`)
};

const zh_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`店铺`)
};

const ar_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة المتجر`)
};

const id_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase`)
};

const it_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vetrina`)
};

const ru_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрина`)
};

const pt_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const ko_seller_nav_storefront = /** @type {(inputs: Seller_Nav_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트`)
};

/**
* | output |
* | --- |
* | "Storefront" |
*
* @param {Seller_Nav_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_storefront = /** @type {((inputs?: Seller_Nav_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_storefront(inputs)
	if (locale === "es") return es_seller_nav_storefront(inputs)
	if (locale === "fr") return fr_seller_nav_storefront(inputs)
	if (locale === "de") return de_seller_nav_storefront(inputs)
	if (locale === "ja") return ja_seller_nav_storefront(inputs)
	if (locale === "zh") return zh_seller_nav_storefront(inputs)
	if (locale === "ar") return ar_seller_nav_storefront(inputs)
	if (locale === "id") return id_seller_nav_storefront(inputs)
	if (locale === "it") return it_seller_nav_storefront(inputs)
	if (locale === "ru") return ru_seller_nav_storefront(inputs)
	if (locale === "pt") return pt_seller_nav_storefront(inputs)
	return ko_seller_nav_storefront(inputs)
});